import React from 'react';
import { Alert } from '@kontentino/ui';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: any;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Log to console so it's visible even in production builds
    // You may integrate with external logging here if desired
    // eslint-disable-next-line no-console
    console.error('Unhandled error in UI:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <Alert variant="danger">
            Something went wrong while rendering the page. Please refresh and try again.
          </Alert>
        </div>
      );
    }

    return this.props.children as React.ReactElement;
  }
}

export default ErrorBoundary;
